import { render, staticRenderFns } from "./FooterTemplate.vue?vue&type=template&id=c2e5596c"
import script from "./FooterTemplate.vue?vue&type=script&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&lang=js"
import style0 from "./FooterTemplate.vue?vue&type=style&index=0&id=c2e5596c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports